import Honeybadger from '@honeybadger-io/js';

import { interimApi } from 'api/InterimApi';

export const runSelfSchedulingInit = async ({
  token,
  navigate,
  hasToken,
  setHasToken,
  seedFromUser,
  initializeWizardForPractice,
  setPractices,
  setNeedsPracticeSelection,
  setInitError
}) => {
  try {
    const { data: authData } = await interimApi('/api/user/check_token', {}, () => {});
    const authValid = !!authData?.token_valid;
    if (authValid) seedFromUser(authData?.user_data);

    if (!token && !authValid) return;

    if (token) {
      const { data } = await interimApi('/api/practice/patient/link/get', { token }, navigate);
      const { code, redirect, patientLink } = data || {};
      if (code === -1 && redirect) {
        navigate(redirect);
        return;
      }
      if (!Array.isArray(patientLink) || patientLink.length === 0) {
        setInitError(true);
        return;
      }
      if (!hasToken) setHasToken(true);
      await initializeWizardForPractice(patientLink[0]);
      return;
    }

    const { data } = await interimApi('/api/self_schedule_v2/practices/get', {}, navigate);
    const fetched = Array.isArray(data?.practices) ? data.practices : [];
    if (fetched.length === 0) {
      setInitError(true);
      return;
    }
    if (fetched.length === 1) {
      await initializeWizardForPractice(fetched[0]);
      return;
    }
    setPractices(fetched);
    setNeedsPracticeSelection(true);
  } catch (error) {
    Honeybadger.notify(`SelfScheduling init error: ${error}`);
    setInitError(true);
  }
};
